<template>
	<tr class="nota-spesa-row" :class="{ 'table-danger text-muted': notaSpesa.FLG_ELIMINATO == 1 }">

		<!-- ===== DESKTOP: colonne classiche ===== -->
		<template v-if="!$root.isMobile">
			<!-- Selezione -->
			<td v-if="showCheckbox" class="table-head-sm text-center" style="width:2%">
				<input type="checkbox" :checked="notaSpesa.SELEZIONATO == 1" @change="$emit('update:selezionato', $event.target.checked ? 1 : 0)" />
			</td>

			<!-- Utente -->
			<td v-if="showUtente" class="table-head-sm text-muted">{{ notaSpesa.NOME_UTENTE }}</td>

			<!-- Data -->
			<td class="table-head-sm text-muted">{{ filters.formatDate(notaSpesa.DATA) }}</td>

			<!-- Descrizione -->
			<td class="table-head-sm">{{ notaSpesa.DESCRIZIONE }}</td>

			<!-- Categoria -->
			<td class="table-head-sm text-muted">{{ categoriaLabel }}</td>

			<!-- Importo -->
			<td class="table-head-sm text-end" :class="notaSpesa.TIPO_MOVIMENTO === 0 ? 'text-danger' : 'text-success'">
				{{ notaSpesa.TIPO_MOVIMENTO === 0 ? '-' : '+' }} € {{ filters.formattaImporto(notaSpesa.IMPORTO) }}
			</td>

			<!-- Progetto -->
			<td v-if="showProgetto" class="table-head-sm">
				<template v-if="notaSpesa.TITOLO_PROGETTO">
					<span v-if="!progettoExpanded">{{ filters.accorciaTesto(notaSpesa.TITOLO_PROGETTO, 20) }}</span>
					<span v-else>{{ notaSpesa.TITOLO_PROGETTO }}</span>
					<i v-if="notaSpesa.TITOLO_PROGETTO.length > 20"
					   :class="progettoExpanded ? 'ph-caret-left' : 'ph-caret-right'"
					   class="ms-1 text-info cursor-pointer"
					   @click.stop="progettoExpanded = !progettoExpanded"></i>
				</template>
				<span v-else class="text-muted">—</span>
			</td>

			<!-- Tipo giustificativo -->
			<td class="table-head-sm text-center">
				<span v-if="notaSpesa.FLG_FATTURA == 1" class="badge bg-info cursor-pointer" @click.stop="apriAllegato('fattura')"><i class="fas fa-file-invoice me-1"></i>Fattura</span>
				<span v-else-if="notaSpesa.FLG_FATTURA == 0" class="badge bg-secondary cursor-pointer" @click.stop="apriAllegato('scontrino')"><i class="fas fa-receipt me-1"></i>Scontrino</span>
				<span v-else class="text-muted">—</span>
			</td>

			<!-- Azioni -->
			<td class="table-head-sm text-center">
				<div v-if="!readOnly" class="dropdown" ref="dropdownEl" @click.stop>
					<a
						href="#"
						class="text-body p-0"
						@click.prevent="toggleDropdown"
						:aria-expanded="dropdownOpen"
						title="Azioni"
						ref="dropdownToggle"
					>
						<i class="ph-list"></i>
					</a>

					<!-- Teleport il menu dropdown fuori dal contesto della tabella -->
					<Teleport to="body">
						<div
							v-if="dropdownOpen"
							class="dropdown-menu dropdown-menu-end show"
							:style="dropdownStyle"
							@click="handleMenuClick"
						>
							<a v-if="showAssociaProgetto && $root.hasFunzionalita('NOTE_SPESE_UPDATE')" href="#" class="dropdown-item" @click.prevent="$emit('apri-azioni', { azione: 'associa', notaSpesa }); closeDropdown()">
								<i class="ph-link-break fa-fw me-2"></i><span class="text-muted me-1">|</span>Associa a progetto
							</a>
							<a v-if="(showModifica || !showAssociaProgetto) && $root.hasFunzionalita('NOTE_SPESE_UPDATE')" href="#" class="dropdown-item" @click.prevent="$emit('apri-azioni', { azione: 'modifica', notaSpesa }); closeDropdown()">
								<i class="far fa-edit fa-fw me-2"></i><span class="text-muted me-1">|</span>Modifica
							</a>
							<a v-if="notaSpesa.FLG_FATTURA != 0 && $root.hasFunzionalita('NOTE_SPESE_UPDATE')" href="#" class="dropdown-item" @click.prevent="$emit('apri-azioni', { azione: 'segna-scontrino', notaSpesa }); closeDropdown()">
								<i class="fas fa-receipt fa-fw me-2"></i><span class="text-muted me-1">|</span>Segna come Scontrino
							</a>
							<a v-if="notaSpesa.FLG_FATTURA != 1 && $root.hasFunzionalita('NOTE_SPESE_UPDATE')" href="#" class="dropdown-item" @click.prevent="$emit('apri-azioni', { azione: 'segna-fattura', notaSpesa }); closeDropdown()">
								<i class="fas fa-file-invoice fa-fw me-2"></i><span class="text-muted me-1">|</span>Segna come Fattura
							</a>
							<a v-if="notaSpesa.FLG_FATTURA == 1 && !notaSpesa.FILE_ALLEGATO && $root.hasFunzionalita('NOTE_SPESE_UPDATE')" href="#" class="dropdown-item" @click.prevent="$emit('apri-azioni', { azione: 'upload-fattura', notaSpesa }); closeDropdown()">
								<i class="fas fa-upload fa-fw me-2"></i><span class="text-muted me-1">|</span>Carica fattura
							</a>
							<div class="dropdown-divider"></div>
							<a href="#" class="dropdown-item text-danger" v-if="$root.isGod && notaSpesa.FLG_ELIMINATO == 1" @click.prevent="$emit('apri-azioni', { azione: 'elimina-definitivamente', notaSpesa }); closeDropdown()">
								<i class="far fa-trash fa-fw me-2"></i><span class="text-muted me-1">|</span>Elimina definitivamente
							</a>
							<a href="#" class="dropdown-item text-success" v-if="$root.isGod && notaSpesa.FLG_ELIMINATO == 1" @click.prevent="$emit('apri-azioni', { azione: 'ripristina', notaSpesa }); closeDropdown()">
								<i class="far fa-redo fa-fw me-2"></i><span class="text-muted me-1">|</span>Ripristina
							</a>
						</div>
					</Teleport>
				</div>
			</td>
		</template>

		<!-- ===== MOBILE: card compatta con dettagli espandibili ===== -->
		<template v-else>
			<td :colspan="colspanMobile" class="p-0 notaspesa-mobile-cell">
				<div class="notaspesa-mobile-row" @click="mobileDetailExpanded = !mobileDetailExpanded">
					<div class="d-flex align-items-center p-2" :class="{ 'flex-wrap': titleExpanded && isTitleTruncated }">
						<input v-if="showCheckbox" type="checkbox" class="me-2 flex-shrink-0"
							:checked="notaSpesa.SELEZIONATO == 1"
							@click.stop
							@change="$emit('update:selezionato', $event.target.checked ? 1 : 0)" />

						<div class="d-flex align-items-center" :class="(titleExpanded && isTitleTruncated) ? 'w-100' : 'flex-grow-1 min-w-0'">
							<i
								class="ph-file-text me-1 flex-shrink-0"
								:class="isTitleTruncated ? 'text-warning' : 'text-muted'"
								:style="{ cursor: isTitleTruncated ? 'pointer' : 'default' }"
								@click.stop="isTitleTruncated && (titleExpanded = !titleExpanded)"
							></i>
							<span class="fw-semibold" :class="(titleExpanded && isTitleTruncated) ? '' : 'text-truncate'">{{ (titleExpanded && isTitleTruncated) ? notaSpesa.DESCRIZIONE : filters.accorciaTesto(notaSpesa.DESCRIZIONE, 28) }}</span>
							<span v-if="notaSpesa.FLG_FATTURA == 1" class="badge bg-info ms-1 flex-shrink-0 cursor-pointer" style="font-size:0.6rem;" title="Fattura" @click.stop="apriAllegato('fattura')"><i class="fas fa-file-invoice"></i></span>
							<span v-else-if="notaSpesa.FLG_FATTURA == 0" class="badge bg-secondary ms-1 flex-shrink-0 cursor-pointer" style="font-size:0.6rem;" title="Scontrino" @click.stop="apriAllegato('scontrino')"><i class="fas fa-receipt"></i></span>
						</div>

						<div class="d-flex align-items-center flex-shrink-0" :class="(titleExpanded && isTitleTruncated) ? 'w-100 justify-content-between mt-1' : 'ms-2'">
							<span class="fw-semibold me-2 text-nowrap" :class="notaSpesa.TIPO_MOVIMENTO === 0 ? 'text-danger' : 'text-success'">
								{{ notaSpesa.TIPO_MOVIMENTO === 0 ? '-' : '+' }} € {{ filters.formattaImporto(notaSpesa.IMPORTO) }}
							</span>

							<div v-if="!readOnly" class="dropdown" ref="dropdownEl" @click.stop>
								<a
									href="#"
									class="text-body p-2"
									@click.prevent="toggleDropdown"
									:aria-expanded="dropdownOpen"
									title="Azioni"
									ref="dropdownToggle"
								>
									<i class="ph-list"></i>
								</a>

								<Teleport to="body">
									<div
										v-if="dropdownOpen"
										class="dropdown-menu dropdown-menu-end show"
										:style="dropdownStyle"
										@click="handleMenuClick"
									>
										<a v-if="showAssociaProgetto && $root.hasFunzionalita('NOTE_SPESE_UPDATE')" href="#" class="dropdown-item" @click.prevent="$emit('apri-azioni', { azione: 'associa', notaSpesa }); closeDropdown()">
											<i class="ph-link-break fa-fw me-2"></i><span class="text-muted me-1">|</span>Associa a progetto
										</a>
										<a v-if="(showModifica || !showAssociaProgetto) && $root.hasFunzionalita('NOTE_SPESE_UPDATE')" href="#" class="dropdown-item" @click.prevent="$emit('apri-azioni', { azione: 'modifica', notaSpesa }); closeDropdown()">
											<i class="far fa-edit fa-fw me-2"></i><span class="text-muted me-1">|</span>Modifica
										</a>
										<a v-if="notaSpesa.FLG_FATTURA == 1 && !notaSpesa.FILE_ALLEGATO && $root.hasFunzionalita('NOTE_SPESE_UPDATE')" href="#" class="dropdown-item" @click.prevent="$emit('apri-azioni', { azione: 'upload-fattura', notaSpesa }); closeDropdown()">
											<i class="fas fa-upload fa-fw me-2"></i><span class="text-muted me-1">|</span>Carica fattura
										</a>
										<div class="dropdown-divider"></div>
										<a href="#" class="dropdown-item text-danger" v-if="$root.isGod && notaSpesa.FLG_ELIMINATO == 1" @click.prevent="$emit('apri-azioni', { azione: 'elimina-definitivamente', notaSpesa }); closeDropdown()">
											<i class="far fa-trash fa-fw me-2"></i><span class="text-muted me-1">|</span>Elimina definitivamente
										</a>
										<a href="#" class="dropdown-item text-success" v-if="$root.isGod && notaSpesa.FLG_ELIMINATO == 1" @click.prevent="$emit('apri-azioni', { azione: 'ripristina', notaSpesa }); closeDropdown()">
											<i class="far fa-redo fa-fw me-2"></i><span class="text-muted me-1">|</span>Ripristina
										</a>
									</div>
								</Teleport>
							</div>
						</div>
					</div>

					<div v-if="mobileDetailExpanded" class="notaspesa-mobile-details p-2 pt-0" @click.stop>
						<div class="row g-2">
							<div class="col-6">
								<small class="text-muted d-block">Data</small>
								{{ filters.formatDate(notaSpesa.DATA) }}
							</div>
							<div class="col-6">
								<small class="text-muted d-block">Categoria</small>
								{{ categoriaLabel || '—' }}
							</div>
							<div class="col-6" v-if="showProgetto">
								<small class="text-muted d-block">Progetto</small>
								{{ notaSpesa.TITOLO_PROGETTO || '—' }}
							</div>
							<div class="col-6" v-if="showUtente">
								<small class="text-muted d-block">Utente</small>
								{{ notaSpesa.NOME_UTENTE || '—' }}
							</div>
						</div>
					</div>
				</div>
			</td>
		</template>

	</tr>
</template>

<script>
import { useDropdownManager } from '@/composables/useDropdownManager.js';
import { ref } from 'vue';

export default {
	name: 'NotaSpesaNode',
	components: {
	},
	props: {
		notaSpesa: {
			type: Object,
			required: true,
		},
		readOnly: {
			type: Boolean,
			default: false,
		},
		showAssociaProgetto: {
			type: Boolean,
			default: false,
		},
		showUtente: {
			type: Boolean,
			default: false,
		},
		showProgetto: {
			type: Boolean,
			default: false,
		},
		showModifica: {
			type: Boolean,
			default: false,
		},
		arrayCategorieSpese: {
			type: Array,
			default: () => [],
		},
		showCheckbox: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['apri-azioni', 'update:selezionato'],
	setup() {
		const dropdownManager = useDropdownManager();
		const dropdownId = ref(null);
		const dropdownOpen = ref(false);
		const dropdownStyle = ref({});
		const dropdownToggle = ref(null);

		return {
			dropdownManager,
			dropdownId,
			dropdownOpen,
			dropdownStyle,
			dropdownToggle,
		};
	},
	data() {
		return {
			filters: global.filters,
			progettoExpanded: false,
			mobileDetailExpanded: false,
			titleExpanded: false,
		};
	},
	computed: {
		categoriaLabel() {
			return (this.arrayCategorieSpese.find(c => c.ICONA == this.notaSpesa.FK_ID_CATEGORIA) || {}).DESCRIZIONE || '';
		},
		isTitleTruncated() {
			return this.notaSpesa.DESCRIZIONE && this.notaSpesa.DESCRIZIONE.toString().length > 28;
		},
		colspanMobile() {
			return 6 + (this.showCheckbox ? 1 : 0) + (this.showUtente ? 1 : 0) + (this.showProgetto ? 1 : 0);
		},
	},
	mounted() {
		// Registra questo dropdown nel sistema centralizzato
		this.dropdownId = this.dropdownManager.registerDropdown(() => {
			this.closeDropdown();
		});

		// Gestisci click fuori dal dropdown per chiuderlo
		document.addEventListener('click', this.handleOutsideClick);
	},
	beforeUnmount() {
		// Pulisci il dropdown dal registro
		if (this.dropdownId) {
			this.dropdownManager.unregisterDropdown(this.dropdownId);
		}
		document.removeEventListener('click', this.handleOutsideClick);
	},
	methods: {
		toggleDropdown() {
			if (this.dropdownOpen) {
				this.closeDropdown();
			} else {
				this.openDropdown();
			}
		},
		openDropdown() {
			this.dropdownManager.openDropdown(this.dropdownId);
			this.dropdownOpen = true;

			this.$nextTick(() => {
				this.updateDropdownPosition();
			});
		},
		closeDropdown() {
			this.dropdownOpen = false;
			this.dropdownManager.closeDropdown(this.dropdownId);
		},
		updateDropdownPosition() {
			if (!this.$refs.dropdownToggle) return;

			const toggle = this.$refs.dropdownToggle;
			const rect = toggle.getBoundingClientRect();

			this.dropdownStyle = {
				position: 'fixed',
				top: `${rect.bottom + 2}px`,
				right: `${window.innerWidth - rect.right}px`,
				left: 'auto',
				zIndex: '99999',
			};
		},
		handleOutsideClick(event) {
			if (!this.dropdownOpen) return;

			const dropdownEl = this.$refs.dropdownEl;
			const toggle = this.$refs.dropdownToggle;

			if (dropdownEl && !dropdownEl.contains(event.target) &&
			    toggle && !toggle.contains(event.target)) {
				this.closeDropdown();
			}
		},
		handleMenuClick(event) {
			event.stopPropagation();
		},
		apriAllegato(tipo) {
			if (tipo == 'fattura') {
				if (!this.notaSpesa.FILE_ALLEGATO) {
					utils.alert.warning('Nessuna fattura caricata');
					return;
				}
				utils.ajaxBlob('theb/note_spese/allegato', { ID_NOTA_SPESA: this.notaSpesa.ID_NOTA_SPESA }, (blob) => {
					const url = URL.createObjectURL(blob);
					window.open(url, '_blank');
				}, true, 'POST');
			} else {
				if (!this.notaSpesa.FK_ID_ELABORAZIONE) {
					utils.alert.warning('Nessuna elaborazione associata a questa nota spesa');
					return;
				}
				utils.ajaxBlob('theb/elaborazione/allegato', { ID_ELABORAZIONE: this.notaSpesa.FK_ID_ELABORAZIONE }, (blob) => {
					const url = URL.createObjectURL(blob);
					window.open(url, '_blank');
				}, true, 'POST');
			}
		},
	},
};
</script>

<style scoped>
.nota-spesa-row {
	vertical-align: middle;
}

.notaspesa-mobile-cell {
	text-align: left;
}

.notaspesa-mobile-row {
	cursor: pointer;
}

.notaspesa-mobile-details {
	background-color: rgba(0, 0, 0, 0.03);
	border-top: 1px solid #ccc;
	font-size: 0.8rem;
}

.min-w-0 {
	min-width: 0;
}

.cursor-pointer {
	cursor: pointer;
}
</style>
